import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { filterArrayEmpty, formatCurrency } from 'lib/riskbase';
import { theme } from 'lib/theme';
import { upperFirst } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL, doSetupBillingAdminDeleteItem } from 'store/actions';
import {
  selectRemoteCustomer,
  selectBillingItem,
  selectRemoteOrganisationId,
} from 'store/remote/selectors';
import { Months } from 'types/types';

type Props = {
  itemId: string;
};

export const BillingItemCard: React.FC<Props> = ({ itemId }) => {
  const dispatch = useDispatch();

  const item = useSelector((state) => selectBillingItem(state, itemId));
  const organisationId = useSelector(selectRemoteOrganisationId);
  const invoiceToCustomer = useSelector((state) =>
    selectRemoteCustomer(state, item?.invoiceToOrganisationId || '-1'),
  );

  if (!item) {
    return null;
  }

  return (
    <CardRow
      label={item.name}
      label2={[
        upperFirst(item.account) +
          (item.invoiceCode !== 'default' ? ` (${item.invoiceCode})` : ''),
        item.months.length === 12
          ? 'Every month'
          : `${Months.filter((m) => item.months.includes(m.name))
              .map((m) => m.nameShort)
              .join(', ')}${item.repeating ? ' (Repeating)' : ''}`,
        item.invoiceToOrganisationId === organisationId
          ? null
          : invoiceToCustomer?.name || null,
      ]
        .filter(filterArrayEmpty)
        .join(' • ')}
      onPress={() =>
        dispatch(
          NAVIGATE_MODAL({
            screen: ModalScreens.SettingsBillingItem,
            params: { itemId: item.id },
          }),
        )
      }
      menuOptions={[
        {
          text: 'Delete Item',
          icon: ICONS.TrashCanLight,
          destructive: true,
          onPress: () =>
            dispatch(doSetupBillingAdminDeleteItem({ id: itemId })),
        },
      ]}
    >
      <Txt
        style={{
          textAlign: 'right',
          color: theme.colors.fieldValueText,
        }}
      >
        {formatCurrency(item.cost)}
      </Txt>
    </CardRow>
  );
};
